import React from 'react'
import { Navigate } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import { useDispatch } from 'react-redux';
import Loading from './Loading';

function Home() {

  const {auth, loading, logout} = useAuth();
  const dispatch = useDispatch();
  
  if(loading)
    return <Loading />;

  if(auth?.roles?.includes('Maker'))
  {
    return <Navigate to="/paymentrequest" replace/>
  }
  else if(auth?.roles?.includes('Checker'))
  {
    return <Navigate to="/paymentapprove" replace/>
  }
  else if(auth?.roles?.includes('Authorizer'))
  {
    return <Navigate to="/paymentapprove" replace/>
  }
  else{
    logout();
    dispatch({ type: 'resetorders', payload: {}})
    dispatch({ type: 'resetorderitems', payload: {}})
    dispatch({ type:'resetpayments', payload: {}})
    return <Navigate to="/login" replace/>
  }
}

export default Home